export default __webpack_public_path__ + "3dbccbe392f012448bc3e48d9b1028d3.svg";